import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { EmptyStateComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { combineLatest, type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportBuilderStore } from '../report-builder.store';
import { getFunnyLoadingMessages$ } from './funny-loader';
import {
  getReportBuilderLoader,
  ILoaderDisplay,
} from './report-builder-loader';
import { DATE_FORMAT, toMoment } from '@principle-theorem/shared';

@Component({
  selector: 'pr-report-builder-loader',
  templateUrl: './report-builder-loader.component.html',
  styleUrls: ['./report-builder-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmptyStateComponent, MatIcon, MatProgressBar, NgCommonModule],
})
export class ReportBuilderLoaderComponent {
  loader$: Observable<ILoaderDisplay | undefined>;
  searchValue$: Observable<string>;

  constructor(public store: ReportBuilderStore) {
    this.searchValue$ = this.store.state$.pipe(
      map((state) => {
        const noDate = 'unknown';
        const dateRange = state.query?.filterDateRange;
        const from = dateRange
          ? toMoment(dateRange.from).format(DATE_FORMAT)
          : noDate;
        const to = dateRange
          ? toMoment(dateRange.to).format(DATE_FORMAT)
          : noDate;
        return `${from} - ${to}.`;
      })
    );

    this.loader$ = combineLatest([
      this.store.state$,
      getFunnyLoadingMessages$(),
    ]).pipe(map(([state, message]) => getReportBuilderLoader(state, message)));
  }
}
